import { useEffect, useRef } from "react";

// Query params that are unrelated to any specific table's own data fetching
// (e.g. GlobalSearchComponent stores its search term in the URL) and must not
// trigger a table refetch on their own.
const IGNORED_QUERY_PARAMS = ["globalSearch"];

function getRelevantQueryString(search: string) {
  const params = new URLSearchParams(search);
  IGNORED_QUERY_PARAMS.forEach((param) => params.delete(param));
  params.sort();
  return params.toString();
}

export default function useQueryStringParser(
  requestFunction: (params: any) => void
) {
  const lastRelevantQueryStringRef = useRef<string | null>(null);

  useEffect(() => {
    const relevantQueryString = getRelevantQueryString(document.location.search);
    if (relevantQueryString === lastRelevantQueryStringRef.current) {
      return;
    }
    lastRelevantQueryStringRef.current = relevantQueryString;

    const searchParams = new URLSearchParams(document.location.search);
    IGNORED_QUERY_PARAMS.forEach((param) => searchParams.delete(param));
    requestFunction(Object.fromEntries(searchParams.entries()));
  }, [document.location.search]);

  return {};
}
